// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"158":"labels","496":"campaigns","644":"account","721":"inbox","806":"user"}[chunkId] + "." + {"158":"60c8b272ed135f11d9a3","496":"e2fc00e1e6d47db4cf99","644":"09ecebc0c59c02e4050e","721":"7120e7bafe721644b261","806":"712c1cb6b769ae4f921b"}[chunkId] + ".js";
};